import { useQuery } from "@tanstack/react-query";
import { Outlet, Navigate } from "react-router-dom-v5-compat";

import Loading from "./Loading";
import { queries, usePageData } from "./queries";

const ProtectedMenuRoute = () => {
  const menuUuid = usePageData().menuUUID;
  const menuQuery = useQuery(queries.menu(menuUuid));

  console.log("MenuLayout render", { menuUuid, menuQuery });
  if (!menuUuid) {
    return <Navigate to="/vouchers" replace />;
  }

  return <PreloadMenu menuUuid={menuUuid} />;
};

const PreloadMenu = ({ menuUuid }: { menuUuid: string }) => {
  const menuQuery = useQuery(queries.menu(menuUuid));

  if (menuQuery.isLoading) {
    return <Loading loadingState="LOADING" />;
  }
  if (menuQuery.isError || !menuQuery.data) {
    throw new Error("Menu not found" + menuQuery.error);
  }
  return <Outlet />;
};

export default ProtectedMenuRoute;
